<template>
  <div class="wrap w1000">
    <div class="keyWordWrap" v-if="!isNoHasSearch">
      <div class="keyL">商品关键词</div>
      <div class="keyC">
        <span v-for="(item, index) in keyList" @click="productKeywordsFn(item, index)"
          :class="{ active: active == index }">{{ item.name }}</span>
      </div>
      <div class="keyR">
        <div class="searchBar">
          <el-input placeholder="请输入商品关键词" v-model="keyWord">
          </el-input>
          <el-button class="searchBtn" @click="changeKey" icon="el-icon-search"></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@/common/bus.js'
import axios from "axios";
import Cookies from "js-cookie";
export default {
  name: "shophead",
  props: {
    isNoHasSearch: false,
  },
  data() {
    return {
      active: 0,
      keyList: [
        { name: '热卖', routerUrl: '/shop?type=hot' },
        { name: '折扣', routerUrl: '/shop?type=supper' },
        { name: '限时', routerUrl: '/shop?type=blackMarket' },
      ],
      keyWord: '',
    }
  },
  created() {
    let router = this.$router.query
    if (router && router.type == 'supper') {
      this.active = 1
    } else if (router && router.type == 'blackMarket') {
      this.active = 2
    } else {
      this.active = 0
    }
  },
  methods: {
    goHome() {       // 进入首页热卖
      this.$router.push({ path: '/shop?type=hot' })
    },

    changeKey() {            // 搜索关键词
      if (Cookies.get('cwsl_token')) {
        this.$emit('searchKey', this.keyWord)
      } else {
        this.$message.error('请先登录')
      }
    },
    productKeywordsFn(item, index) {        // 点击商品关键词
      if (Cookies.get('cwsl_token')) {
        if (item.name == '限时') {
          this.$message.info('系统升级，尽情期待！！！')
        }else {
          this.active = index
          // console.log(item.routerUrl,);

          this.$router.push({ path: item.routerUrl })
        }


      } else {
        this.$message.error('请先登录')
      }
    },
    routeChange(to, from) {                  // 路由参数切换
      if (to.query.type == 'hot') {           // 热卖
        this.active = 0
      } else if (to.query.type == 'supper') {  // 超值购
        this.active = 1
      } else if (to.query.type == 'blackMarket') {  // 超值购
        this.active = 2
      }
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        this.routeChange(to, from)
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  }
}
</script>

<style lang="less">
.keyR {
  .searchBtn {
    padding: 0;
    border: none;
    background: #ffffff;
    border-radius: 0;
    width: 45px;
    line-height: 38px;
    cursor: pointer;

    .el-icon-search {
      font-size: 18px;
      font-weight: 700;
      color: #5472F6;
    }
  }

  .el-input {
    input {
      height: 100%;
      border: none;
      background: #5472F6;
      color: #fff;
      font-size: 16px;

      &::placeholder {
        font-size: 16px;
        color: #fff !important;
      }
    }
  }
}
</style>
<style scoped lang="less">
.logoWrap {
  display: flex;
  padding: 33px 0 25px;
  align-items: center;
  vertical-align: middle;

  .logo {
    margin-right: 40px;
    cursor: pointer;
  }

  .noticeWrap {
    flex: 1;

    .notice {
      display: flex;
      padding: 15px 22px;
      align-items: center;
      vertical-align: middle;
      height: 60px;
      border: 2px solid #FF2137;
      box-sizing: border-box;
      border-radius: 4px;

      .pic {
        margin-right: 10px;
      }

      .txt {
        width: 600px;
        overflow: hidden;
        white-space: nowrap;

        /* 防止换行 */
        p {
          font-size: 22px;
          word-break: keep-all;
          color: #333;
          display: inline-block;
          /* 放置多个p元素 */
          margin: 0 100px 0 30px;
          animation: marquee 30s linear infinite;
        }
      }
    }
  }
}

.keyWordWrap {
  display: flex;
  padding: 0 30px;
  color: #fff;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  // border: 1px solid #FF0098;
  background: #5472F6;

  .keyL {
    font-size: 24px;
  }

  .keyC {
    width: 380px;
    display: flex;
    justify-content: space-between;

    span {
      font-size: 24px;
      font-weight: 100;
      cursor: pointer;
    }

    .active {
      font-size: 28px;
    }
  }

  .keyR {
    .searchBar {
      display: flex;
      width: 290px;
      height: 34px;
      border: 2px solid #FFFFFF;
      border-radius: 2px;
    }
  }
}

/* 无缝滚动动画 */
@keyframes marquee {
  0% {
    transform: translate(0, 0);
  }

  100% {
    transform: translate(-100%, 0);
  }
}
</style>
